import React, { FC } from "react";
import styles from "./index.module.scss";
import { IOccupationCardProps } from "types/components/common/occupationCard";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { AutoTextSize } from "auto-text-size";

const colors = ["#5A70E8", "#004E99", "#3A54DE"];

const OccupationCard: FC<IOccupationCardProps> = ({
  item,
  className,
  onClick,
  subCarousel,
  isOrange,
  idx,
}) => {
  const { dir, language } = useAppSelector(getSettings);
  return (
    <div
      className={styles["occupation-card-wrapper"]}
      onClick={onClick}
      title={item?.title?.[language]}
    >
      <div
        className={`
        cursor-pointer
        ${styles["occupation-card"]}
        ${
          isOrange
            ? styles["occupation-card-orange"]
            : subCarousel
            ? styles["occupation-card-blue"]
            : ""
        } ${className}
        ${
          isOrange
            ? "bg-[#F29423] border-4 border-white !mt-8 lg:!mt-10 scale-[1.4] lg:scale-[1.5]"
            : `bg-[${idx! === 0 ? "#DEE2FB" : colors[idx! % 3]}]`
        }
        `}
        dir={dir}
        lang={language}
      >
        <AutoTextSize
          className="h-full !flex justify-center items-center px-1.5 line-clamp-3 text-ellipsis truncate"
          minFontSizePx={14}
          maxFontSizePx={20}
          mode="multiline"
        >
          {
          item?.title?.[language].length > 20
            ? item?.title?.[language].slice(0, 20) + "..."
            :
            item?.title?.[language]}
        </AutoTextSize>
      </div>
    </div>
  );
};

export default OccupationCard;
